import IntegrationsStoreLoader from './IntegrationsStoreLoader';

export default IntegrationsStoreLoader;
